import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import Heartintune from "../../../../components/special-event/Heartintune";
import Layout from "../../../../layout";
import Seo from "../../../../components/seo";
import "../../../../assets/styles/present_event.scss";
import "../../../../assets/styles/special_event.scss";

const PreceptorSeminar = () => {
  return (
    <>
      <Seo
        title="Preceptor Seminar"
        keyword="Preceptor Seminar"
        description="Preceptor Seminar"
      />
      <Layout isSticky wrapperClass="special_event preceptor-seminar-wr">
        <div>
          <div className="banner_wrapper bandara_banner_style position-relative">
            <div className="heartfulness-img">
              <StaticImage
                src="https://cdn-prod.heartfulness.org/images/Events/vow-wow-event/the-way-of-love-black.png"
                alt="Meditation event at World's largest meditation center"
                placeholder="blurred"
              />
            </div>
          </div>
          <section className="container py-4 my-4 preceptor-seminar">
            <div className="row">
              <div className="col-12">
                <h5>INVITE FOR PRECEPTOR SEMINAR</h5>
                <span className="readThrough">
                  (Read through the Below and Agree to Register at the bottom of
                  the page)
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-12 mt-4">
                <p>
                  We are delighted to Invite Preceptors for Seminar on April 26
                  and 27, 2023.
                </p>
                <p>
                  Once you register, accommodation booking and transportation
                  options will become available on the &quot;My
                  Registration&quot; page. You may select the accommodation
                  options within the ashram.
                </p>
                <p>
                  <strong>Book Premium / Comfort Dorm / accommodation</strong>
                </p>
                <p>
                  The online booking for Comfort Dorms for preceptors is
                  available on My Registration. Please print and carry the
                  receipt when you arrive.
                </p>
                <p>
                  Special paid accommodation with bunk beds or cots will require
                  registration. The booking and payment window is open on the
                  &quot;My Registration&quot; page. Please select the option
                  &quot;Opt for paid accommodation in Kanha&quot; in your stay
                  preferences.
                </p>
                <p>
                  Those already residing in Kanha or nearby can select &quot;Own
                  accommodation in Kanha&quot;.
                </p>
                <p>
                  General free accommodation is arranged at multiple facilities
                  in the North & South wings to provide everyone who comes, with
                  a roof over their heads and bathroom facilities within
                  walkable distance. Dining hall facilities are available within
                  250 meters. General accommodation will be allocated on
                  arrival. To register for the same, please select &quot;Opt for
                  free accommodation in Kanha&quot; in your stay preferences.
                </p>
                <p>
                  <strong>Modifications:</strong>
                </p>
                <p>
                  For any modifications please visit the &quot;Confirmed
                  Bookings&quot; tab on Special Accommodation page. Kindly note
                  the accommodation payments are
                  <strong> non-refundable</strong>. There wont be any
                  cancellations allowed for confirmed accommodation.
                </p>
                <p>
                  <strong>Arrival & Departure Dates:</strong>
                </p>
                <p>
                  Please keep your arrival / departure information up to date in
                  your registration at My Registration.
                  <strong>
                    <i>
                      We request you to plan your departure latest by May 3rd,
                      2023 to carry out all necessary cleaning and maintenance
                      on the premises.
                    </i>
                  </strong>{" "}
                  There is no transport provided by the transportation team. But
                  provision of pre-booking Bus can be done if more than 40
                  people are arriving. Request to send an email to&nbsp;
                  <a
                    href="mailto:transport@heartfulness.org"
                    className="mailId"
                    target="_blank"
                    rel="noreferrer"
                  >
                    transport@heartfulness.org
                  </a>{" "}
                  with the details.
                </p>
                <p>
                  <i>
                    Every drop counts. If you are planning to travel by flight,
                    please book your flight ticket on MakeMyTrip and Goibibo
                    through{" "}
                    <a
                      href="https://hfnlife.com/pages/hfnl-fe-affiliate-program"
                      className="links"
                      target="_blank"
                      rel="noreferrer"
                    >
                      HFN Life
                    </a>{" "}
                    and contribute to the Heartfulness movement @ no extra cost
                  </i>
                </p>
                <p>
                  <strong>Suggested Donation:</strong>
                </p>
                <p>
                  The Heartfulness organizations run on donations and grants,
                  and are registered as charitable non-profit organizations.
                  Please consider donating whatever you feel to give, but there
                  there is no compulsion to donate. It all depends on your means
                  and willingness!
                </p>
                <div className="donation">
                  <a
                    href="https://donations.heartfulness.org/donation-general-fund/"
                    className="donateNowBtn"
                    target="_blank"
                    rel="noreferrer"
                  >
                    DONATE NOW
                  </a>
                </div>
                <p>
                  <strong>Medical Advisory:</strong>
                </p>
                <p>
                  There are very basic medical facilities at Kanha. If you have
                  a chronic pre-existing medical condition, like diabetes, heart
                  problems, mental or psychiatric conditions you are requested
                  not to visit. All visitors over the age of 70 years are
                  requested to avoid traveling and encouraged to attend
                  virtually. It is vital that all senior citizens who are under
                  medication, are accompanied by their family members or
                  friends.
                </p>
                <p className="noteText">
                  <strong>
                    This seminar is strictly for preceptors and rest of the
                    abhyasis are requested to attend satsangs at the local
                    center as the April bhandara celebration is de-centralised.
                  </strong>
                </p>
                <p>
                  Please feel free to call our Toll Free number: 1800 103 7726
                  for any information or WhatsApp: 7871077888, or write to&nbsp;
                  <a
                    href="mailto:welcome@heartfulness.org"
                    className="mailId"
                    target="_blank"
                    rel="noreferrer"
                  >
                    welcome@heartfulness.org
                  </a>
                  .
                </p>
                <p>
                  Regards,
                  <br />
                  Preceptor Seminar Team,
                  <br />
                  Kanha Shanti Vanam
                </p>
                {/* <p>
                  <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    label=" I hereby acknowledge that I have read and understood the information above."
                    sx={{ display: "inline-block" }}
                  />
                </p> */}
              </div>
            </div>
            {/* <div className="row">
              <div className="col-12">
                <div className="mb-4 pb-2">
                  <EventRegistrations
                    eventId={preceptorSeminar?.id}
                    styleProp={styleProp2}
                    computePnrPageUrl={computePnrPageUrl}
                    data={data}
                    customConfig={customConfig}
                    registerBtnText="Register"
                  />
                </div>
              </div>
            </div> */}
          </section>
          <Heartintune />
        </div>
      </Layout>
    </>
  );
};

export default PreceptorSeminar;
